import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { WidgetConfiguration } from '../widget/config.widget.model';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';
import { WidgetService } from '../widget/widget.service';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { MetricFocus } from './metric-focus.widget.model';

@Component({
    selector: 'cmps-widget-metric-focus',
    templateUrl: './metric-focus.widget.component.html',
})
export class MetricFocusWidgetComponent implements OnInit, OnDestroy {
    i18n = TranslationKeyMap;
    private _sub: Subscription;
    hasPendingData: boolean;
    data: MetricFocus[];

    // TODO revise
    showGoToDashboardButton: boolean;

    constructor(
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _widgetService: WidgetService,
        private readonly _service: LegacyWidgetService,
    ) {
        this._evalAttributes();
    }

    ngOnInit(): void {
        this._sub = this._widgetService.dateRange.subscribe((dateRange) => {
            this.data = null;
            this.hasPendingData = true;
            this._service
                .metricFocus(this.config.definitionId)
                // eslint-disable-next-line no-return-assign
                .subscribe(
                    (data) => (this.data = data),
                    // eslint-disable-next-line n/handle-callback-err, no-return-assign
                    (error) => (this.hasPendingData = false),
                    // eslint-disable-next-line no-return-assign
                    () => (this.hasPendingData = false),
                );
        });
    }

    ngOnDestroy(): void {
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }

    // TODO revise
    private _evalAttributes(): void {
        this.config.attributes.forEach((attr) => {
            // if (attr.name === 'DisplayAllPillars')
            // if (attr.name === 'DisplayVariance')
            // if (attr.name === 'Format')
            // if (attr.name === 'IncludeQTR')
            // if (attr.name === 'IncludeSG')
            // if (attr.name === 'ShowDateSelector')
            // if (attr.name === 'ShowGoToDashboardButton') this.showGoToDashboardButton = attr.value !== '0' && attr.value.toLowerCase() !== 'false';
            // if (attr.name === 'TimeFrame')
        });
    }
}
